import { AiFillSetting } from 'react-icons/ai'
import { BiPurchaseTag, BiSliderAlt } from 'react-icons/bi'
import { BsCreditCard2Front, BsLayers, BsSearch } from 'react-icons/bs'
import { FaTruckLoading, FaBezierCurve } from 'react-icons/fa'
import { MdThumbsUpDown } from 'react-icons/md'
import { VscHistory } from 'react-icons/vsc'

import type { ILink } from '@base/@types/components/Layout/Navigator'

const parametrizationLinks: ILink = {
  group: 'Parametros',
  icon: <BiSliderAlt />,
  roles: [
    'Diretor',
    'AnalistaCompra',
    'AnalistaDistribuicao',
    'Parceiro',
    'Administrador',
    'AnalistaPlanejamento',
    'AnalistaComercial',
    'GerenteProduto',
    'Analista',
    'Loja',
    'Assistente',
    'GerenteLoja'
  ],
  menu: [
    {
      name: 'Abastecimento',
      path: '/parametrizacao/abastecimento',
      icon: <FaTruckLoading />,
      description: 'Parametrização de produto',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',
        'AnalistaComercial',
        'GerenteProduto',
        'Analista',
        'Loja',
        'Assistente',
        'GerenteLoja'
      ]
    },
    {
      name: 'Revisão',
      path: '/parametrizacao/revisao',
      icon: <BsSearch />,
      description: 'Aprovação e acompanhamento de mudança de status do produto',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',
        'Analista',
        'Assistente'
      ]
    },
    {
      name: 'Produto Similar',
      path: '/parametrizacao/produto-similar',
      icon: <BsLayers />,
      description: 'Cadastro de produtos similares',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',

        'Analista',
        'Assistente'
      ]
    },
    {
      name: 'Faturamento Mín.',
      path: '/parametrizacao/faturamento-minimo',
      icon: <BsCreditCard2Front />,
      description: 'Cadastro de faturamento mínimo do fornecedor',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',

        'Analista',
        'Assistente'
      ]
    },
    {
      name: ' Incremento de Estoque',
      path: '/parametrizacao/incremento',
      icon: <MdThumbsUpDown />,
      description: 'Cadastro de incremento do estoque',
      roles: ['Administrador', 'AnalistaPlanejamento']
    },
    {
      name: ' Config. Liberações',
      path: '/parametrizacao/configuracoes',
      icon: <AiFillSetting />,
      description: 'Cadastro de configuracoes de parametros por perfil',
      roles: ['Administrador', 'AnalistaPlanejamento']
    },
    {
      name: ' Config. Curvas',
      path: '/parametrizacao/curvas',
      icon: <FaBezierCurve />,
      description: 'Cadastro de configuracoes de parametros de curvas ABCD..',
      roles: ['Administrador', 'AnalistaPlanejamento']
    },
    {
      name: 'Rel. Modificações',
      path: '/parametrizacao/relatorio-modificacoes',
      icon: <VscHistory />,
      description: 'Relatório de modificações semanais — EMax',
      roles: ['Administrador', 'AnalistaCompra']
    },
    {
      name: 'Config. Reab',
      path: '/parametrizacao/reab',
      icon: <FaTruckLoading />,
      description: 'Cadastro de configurações de parâmetros para o Reab.',
      roles: [
        'Administrador',
        'AnalistaPlanejamento',
        'AnalistaDistribuicao',
        'Parceiro'
      ]
    },
    {
      name: 'Config. Compras',
      path: '/parametrizacao/config/compra',
      icon: <BiPurchaseTag />,
      description: 'Cadastro de configurações de parâmetros para o Compras.',
      roles: ['Administrador', 'AnalistaPlanejamento', 'AnalistaCompra']
    }
  ]
}

export default parametrizationLinks
